import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-about-us",
    templateUrl: "./about-us.component.html",
    styleUrls: ["./about-us.component.scss"],
    standalone: false
})
export class AboutUsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  scrollTo(id: string) {
    const element = window.document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", inline: "nearest" });
    }
  }
}
